import api from "./api.service";

export function getConsent(options = {}) {
  return api.get("/web/consent", options);
}

export function saveConsent(payload, options = {}) {
  return api.post("/web/consent", payload, options);
}

const consentApi = { getConsent, saveConsent };

export default consentApi;
